export default __webpack_public_path__ + "static/media/note-icon.b0d61d2c.svg";